import React from 'react';
import { Navigate } from 'react-router-dom';
// import { toast } from 'react-toastify'; //? React-Toastify
import { useAuth } from './UserAuth';

export const ProtectedRoutes = ({ children }) => {
  const { Token } = useAuth();

  if (!Token) {
    return <Navigate to='/login' />;
  }
  return children;
};
